export const PERSONAL_TAG = "PERSONAL"
export const CUSTOM_TAG = "custom"